import { render } from "./DeleteUserForm.vue?vue&type=template&id=68dbcb18"
import script from "./DeleteUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteUserForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Profile/Partials/DeleteUserForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68dbcb18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68dbcb18', __exports__)) {
    api.reload('68dbcb18', __exports__)
  }
  
  module.hot.accept("./DeleteUserForm.vue?vue&type=template&id=68dbcb18", () => {
    api.rerender('68dbcb18', render)
  })

}


export default __exports__